/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { auth, db } from "../../../firebase";

import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import MultiSelect from "../../../components/common/MultiSelect/index";

import {
  Space,
  Select,
  Button,
  Form,
  DatePicker,
  Row,
  Col,
  Popover,
} from "antd";

import { FaQuestionCircle } from "react-icons/fa";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";

import {
  guestcsrdassignedto,
  contactinfo,
  guestfilterinboxby,
} from "../../../data/guestcards";

import "./GuestCards.css";
import {
  coldData,
  contactsData,
  followUpData,
} from "../../../data/guestCardsData";
import FilterContainer from "../../../components/common/FilterContainer";
import { Link } from "react-router-dom";
import AllGuestCards from "./components/AllGuestCards";
import { useForm } from "antd/lib/form/Form";
import { toast } from "react-hot-toast";
import { useAuthState } from "react-firebase-hooks/auth";

const content = (
  <div className="inboxcriteria">
    <p>
      <strong>Needs First Contact:</strong> Active guest cards with the most
      recent activity as a new inquiry.
    </p>
    <p>
      <strong>Needs Follow Up:</strong> Active guest cards with the most recent
      activity as an inbound message, excluding "first contact" guest cards.
    </p>
    <p>
      <strong>Going Cold:</strong> Active guest cards with the most recent
      activity as an outgoing message at least 7 days old.
    </p>
  </div>
);

const GuestCardsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod(
      "New Guest Card",
      "1",
      "",
      "",
      "/leasing/guest-cards/new-guest-card"
    ),
    RightBarMethod(
      "Bulk Guest Cards",
      "2",
      "",
      "",
      "/leasing/guest-cards/bulk"
    ),
    RightBarMethod(
      "Set Showing Availibility",
      "3",
      "",
      "",
      "/showing-availability"
    ),
    RightBarMethod(
      "Manage Lockboxes",
      "4",
      "",
      "",
      "/leasing/guest-cards/manage-lockboxes"
    ),
    RightBarMethod("Showing with CodeBox", "5", "", "", ""),
  ]),

  RightBarMethod(
    " CALENDAR",
    "t2",
    <i className="fa-solid fa-calendar-days"></i>,
    [RightBarMethod("View Calendar", "6", "", "", "/CalendarPage")]
  ),

  RightBarMethod(
    " REPORTS",
    "t3",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Guest Card Interest", "7", "", "", "/"),
      RightBarMethod("Guest Card Inquiries", "8", "", "", "/"),
      RightBarMethod("Prospect Source Tracking", "9", "", "", "/"),
      RightBarMethod("Owner Leasing", "10", "", "", "/"),
      RightBarMethod("Premium Leads Billing Detail", "11", "", "", "/"),
      RightBarMethod("Leasing Agent Performance", "12", "", "", "/"),
    ]
  ),

  RightBarMethod(
    " HELP TOPICS",
    "t4",
    <i className="fa-solid fa-circle-question"></i>,
    [
      RightBarMethod("Using Guest Cards", "13", "", "", "/"),
      RightBarMethod("Premium Leads", "14", "", "", "/"),
    ]
  ),
];

const options = [];
for (let i = 10; i < 36; i++) {
  options.push({
    label: i.toString(36) + i,
    value: i.toString(36) + i,
  });
}

const guestStatus = [
  {
    value: "Pre-Qualified",
  },
  {
    value: "Pre-Qualified",
  },
  {
    value: "Application Completed",
  },
  {
    value: "Active",
  },
  {
    value: "Inactive",
  },
  {
    value: "Cold",
  },
];

const source = [
  {
    value: "Pre-Qualified",
  },
  {
    value: "Application Completed",
  },
  {
    value: "Active",
  },
  {
    value: "Inactive",
  },
  {
    value: "Cold",
  },
];

const LeadType = [
  { value: "Free" },
  { value: "Premium" },
  { value: "Hang Up" },
  { value: "Refunded" },
];
const inboxTotalNotifications =
  contactsData.length + followUpData.length + coldData.length;

function GuestCards() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState(data);
  const [inboxCardToggle, setInboxCardToggle] = useState(false);
  const [inboxToggle, setInboxToggle] = useState(false);
  const [inboxContactToggle, setInboxContactToggle] = useState(false);
  const [inboxFollowUpToggle, setInboxFollowUpToggle] = useState(false);
  const [inboxColdToggle, setInboxColdToggle] = useState(false);
  const [inboxTotal, setInboxTotal] = useState(inboxTotalNotifications);
  const [showAllGuestCards, setShowAllGuestCards] = useState(false);
  const [propertyUnits, setPropertyUnits] = useState([]);
  const [sources, setSources] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [user, loading] = useAuthState(auth);
  const [propertiesList, setPropertiesList] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [form] = useForm();

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);


  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchProperties = async () => {
      try {
        const propertyRef = collection(
          db,
          "companies",
          companyName,
          "properties"
        );
        const snapshot = await getDocs(propertyRef);

        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          value: doc.id,
          label: doc.data().propertyNameAddress.propertyName,
        }));

        setPropertiesList(fetchedData);

        // console.log("fetchedData", fetchedData);
        // console.log("properties", properties);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchProperties();
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchGuestCards = async () => {
      try {
        const guestCardRef = collection(
          db,
          "companies",
          companyName,
          "guestCards"
        );
        const snapshot = await getDocs(guestCardRef); // Use getDocs to fetch the collection

        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setData(fetchedData);
        setFilteredData(fetchedData);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchGuestCards();
  }, [companyName, isCompanyNameFetched]);

  const compareObjectFields = (object, target) => {
    // Compare the dynamically generated object fields with the target
    for (let key in object) {
      if (object.hasOwnProperty(key) && object[key] === target) {
        return true;
      }
    }
    return false;
  };

  const handleFormSubmit = () => {
    const formData = form.getFieldsValue();
    Object.keys(formData).forEach((field) => {
      if (formData[field] === undefined) {
        formData[field] = "";
      }
    });

    const filteredDataSource = data.filter(
      (record) =>
        (formData.contactInfo === "" ||
          record.guestContact?.phoneNumber.includes(formData.contactInfo)) &&
        record.guestContact?.assignTo
          ?.toLowerCase()
          .includes(formData.assignTo.toLowerCase()) &&
        (propertyUnits.length === 0 ||
          propertyUnits.some((value) =>
            compareObjectFields(record.guestInterests, value)
          )) &&
        (sources.length === 0 ||
          sources.some((value) =>
            record.guestContact?.source
              ?.toLowerCase()
              .includes(value.toLowerCase())
          )) &&
        (statuses.length === 0 ||
          statuses.some((value) =>
            record?.status?.toLowerCase().includes(value.toLowerCase())
          ))
    );
    setFilteredData(filteredDataSource);
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <div className="guest-cards">
        <PageHeading heading="Guest Cards" />
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <Row>
              <Col
                span={24}
                onClick={() => setInboxCardToggle(!inboxCardToggle)}
                className="collapse-container"
              >
                {inboxCardToggle ? (
                  <MdKeyboardArrowUp size={20} />
                ) : (
                  <MdKeyboardArrowDown size={20} />
                )}
                <span>Guest Inbox Card</span>
              </Col>
              {inboxCardToggle ? (
                <Col span={24} className="main-collapse-container">
                  <Row>
                    <Col span={24} className="input-field-container">
                      <Row align="middle">
                        <Col span={3}>
                          <span>Filter Inbox by:</span>
                        </Col>
                        <Col span={21}>
                          <MultiSelect
                            options={guestfilterinboxby}
                            placeholder="Select..."
                            className="filter-select"
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      span={24}
                      onClick={() => setInboxToggle(!inboxToggle)}
                      className="collapse-container parent"
                    >
                      {inboxToggle ? (
                        <MdKeyboardArrowUp size={20} />
                      ) : (
                        <MdKeyboardArrowDown size={20} />
                      )}
                      <span className="span-tag">{inboxTotal}</span>
                      <span>Inbox</span>
                      <Popover
                        placement="right"
                        title="Guest Card Inbox Criteria"
                        content={content}
                        className="child"
                      >
                        <FaQuestionCircle className="inbox-popover" />
                      </Popover>
                    </Col>
                    {inboxToggle ? (
                      <Col span={24}>
                        <Row>
                          <Col
                            span={24}
                            onClick={() =>
                              setInboxContactToggle(!inboxContactToggle)
                            }
                            className="collapse-container"
                          >
                            {inboxContactToggle ? (
                              <MdKeyboardArrowUp size={20} />
                            ) : (
                              <MdKeyboardArrowDown size={20} />
                            )}
                            <span className="span-tag">
                              {contactsData.length}
                            </span>
                            <span>Needs First Contact</span>
                          </Col>
                          {inboxContactToggle ? (
                            <Col span={24} className="contacts-container">
                              <Row className="table-header ip">
                                <Col span={2} className="table-col">
                                  <span>Prospect</span>
                                </Col>
                                <Col span={16} className="table-col">
                                  <span>Interested In</span>
                                </Col>
                                <Col span={2} className="table-col">
                                  <span>Source</span>
                                </Col>
                                <Col span={4} className="table-col">
                                  <span>Most Recent Activity</span>
                                </Col>
                              </Row>
                              {contactsData.map((item, index) => {
                                return (
                                  <Row key={index} className="row-color ip">
                                    <Col span={2} className="table-row">
                                      <span>{item.prospect}</span>
                                    </Col>
                                    <Col span={16} className="table-row">
                                      <span>{item.interestedIn}</span>
                                    </Col>
                                    <Col span={2} className="table-row">
                                      <span>{item.Source}</span>
                                    </Col>
                                    <Col span={4} className="table-row">
                                      <span>{item.activity}</span>
                                    </Col>
                                  </Row>
                                );
                              })}
                            </Col>
                          ) : null}
                          <Col
                            span={24}
                            onClick={() =>
                              setInboxFollowUpToggle(!inboxFollowUpToggle)
                            }
                            className="collapse-container"
                          >
                            {inboxFollowUpToggle ? (
                              <MdKeyboardArrowUp size={20} />
                            ) : (
                              <MdKeyboardArrowDown size={20} />
                            )}
                            <span className="span-tag">
                              {followUpData.length}
                            </span>
                            <span>Needs Follow Up</span>
                          </Col>
                          {inboxFollowUpToggle ? (
                            <Col span={24}>Follow Up</Col>
                          ) : null}
                          <Col
                            span={24}
                            onClick={() => setInboxColdToggle(!inboxColdToggle)}
                            className="collapse-container"
                          >
                            {inboxColdToggle ? (
                              <MdKeyboardArrowUp size={20} />
                            ) : (
                              <MdKeyboardArrowDown size={20} />
                            )}
                            <span className="span-tag">{coldData.length}</span>
                            <span>Going Cold</span>
                          </Col>
                          {inboxColdToggle ? (
                            <Col span={24}>
                              <Row className="table-header ip">
                                <Col span={2} className="table-col">
                                  <span>Prospect</span>
                                </Col>
                                <Col span={16} className="table-col">
                                  <span>Interested In</span>
                                </Col>
                                <Col span={2} className="table-col">
                                  <span>Source</span>
                                </Col>
                                <Col span={4} className="table-col">
                                  <span>Most Recent Activity</span>
                                </Col>
                              </Row>
                              {coldData.map((item, index) => {
                                return (
                                  <Row key={index} className="row-color ip">
                                    <Col span={2} className="table-row">
                                      <span>{item.prospect}</span>
                                    </Col>
                                    <Col span={16} className="table-row">
                                      <span>{item.interestedIn}</span>
                                    </Col>
                                    <Col span={2} className="table-row">
                                      <span>{item.Source}</span>
                                    </Col>
                                    <Col span={4} className="table-row">
                                      <span>{item.activity}</span>
                                    </Col>
                                  </Row>
                                );
                              })}
                            </Col>
                          ) : null}
                        </Row>
                      </Col>
                    ) : null}
                  </Row>
                </Col>
              ) : null}
            </Row>
          </Col>
          <Col span={24}>
            <FilterContainer heading="Filter guest cards by using any of the search filters below:">
              <Form
                name="basic"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 16 }}
                initialValues={{ remember: true }}
                autoComplete="off"
                colon={false}
                onFinish={handleFormSubmit}
                onFinishFailed={onFinishFailed}
                form={form}
              >
                <Form.Item
                  label="Properties, Units or Campaigns"
                  name="propertyUnits"
                >
                  <Select
                    mode="multiple"
                    options={propertiesList}
                    placeholder="Search by unit, property, group, campaign or portfolio"
                  />
                </Form.Item>
                <Form.Item label="Status" name="status">
                  <Select
                    mode="multiple"
                    options={guestStatus}
                    placeholder="Search by status"
                  />
                </Form.Item>
                <Form.Item label="Source" name="sources">
                  <Select
                    mode="multiple"
                    options={source}
                    placeholder="Search by source"
                  />
                </Form.Item>
                <Form.Item label="Lead Type" name="leadType">
                  <Select
                    mode="multiple"
                    options={LeadType}
                    placeholder="Search by lead type"
                  />
                </Form.Item>
                <Form.Item label="Contact Info" name="contactInfo">
                  <Select
                    showSearch
                    placeholder="Search by name, email address, or phone"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={contactinfo}
                  />
                </Form.Item>
                <Form.Item label="Assigned To" name="assignTo">
                  <Select
                    showSearch
                    placeholder="Search by assigned user"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={guestcsrdassignedto}
                  />
                </Form.Item>
                <Form.Item label="Inquiry Received">
                  <Row justify="space-between" align="middle">
                    <Col>
                      <Space className="dtepckr" direction="vertical">
                        <DatePicker />
                      </Space>
                    </Col>
                    <Col>
                      <span>To</span>
                    </Col>
                    <Col>
                      <Space className="dtepckr" direction="vertical">
                        <DatePicker />
                      </Space>
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item label=" ">
                  <Button type="primary" htmlType="submit">
                    Search
                  </Button>
                </Form.Item>
              </Form>
            </FilterContainer>
          </Col>
        </Row>
        <Row justify="center">
          {showAllGuestCards ? (
            <AllGuestCards data={filteredData} />
          ) : (
            <Col>
              <p>
                No guest cards were found that match this criteria.{" "}
                <span
                  className="onclick-text"
                  onClick={() => setShowAllGuestCards(true)}
                >
                  Show all guest cards
                </span>{" "}
                or
                <Link to="/leasing/guest-cards/new-guest-card">
                  {" "}
                  add a new guest card.
                </Link>
              </p>
            </Col>
          )}
          <Col>{}</Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={GuestCardsRightBar} />
      </div>
    </>
  );
}
export default GuestCards;
